<template>
  <z-dialogo ref="dialogo" titulo="Veículos" scrollable dividers no-padding largura="900px" altura="383px">

    <template v-slot:prepend>
      <v-toolbar flat color="white">
        <z-text-field-search
          v-model="busca"
          ref="busca"
          width="100%"
          select
          filled
          autofocus
          @focus="is_busca_focused = true"
          @blur="is_busca_focused = false"
          @keydown.enter="buscar"
          @click:clear="limparBusca"
        ></z-text-field-search>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn small fab color="primary" class="ml-3 mr-1" v-on="on" @click="adicionar">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Adicionar Veículo</span>
        </v-tooltip>
      </v-toolbar>
    </template>

    <template v-slot:texto>
      <div ref="topo"></div>
      <z-loading :loading="carregando">
        <v-data-table
          mobile-breakpoint="0"
          disable-pagination
          disable-sort
          hide-default-footer
          :headers="headers"
          :items="itens_busca"
          :loading="carregando"
          fixed-header_
          height_="383px"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="(item, index) in items"
                ref="urls"
                :key="index"
                class="apontador noselect"
                :class="{'active': isActive(index)}"
                @click="selecionar(item)"
              >
                <td class="text-no-wrap">{{ item.placa }}</td>
                <td>{{ item.marca }}</td>
                <td class="text-no-wrap">{{ item.modelo }}</td>
                <td>{{ item.ano }}</td>
                <td>{{ item.ultima_os }}</td>
                <td>{{ item.ultimo_cliente_id || '' }}</td>
                <td>{{ item.data_ultima_os | dataBR }}</td>
              </tr>
            </tbody>

          </template>
        </v-data-table>
      </z-loading>
    </template>

    <template v-slot:actions_left>
      <span class="text-subtitle-2">Veículos encontradas: {{ itens_busca.length }}</span>
    </template>
    <template v-slot:actions_right>
      <v-btn color="primary" @click="fechar()">Fechar</v-btn>
    </template>

  </z-dialogo>
</template>

<script>

import veiculosApi from "@/app/services/veiculos";
import { abrirJanela } from "@/app/helpers/utils";

import buscas_mixin from "@/app/mixins/buscas";


  export default {
    name: 'DialogoBuscarVeiculos',

    mixins: [buscas_mixin],

    data() {
      return {
        headers: [
          { text: "Placa", value: "placa" },
          { text: "Marca", value: "marca" },
          { text: "Modelo", value: "modelo" },
          { text: "Ano", value: "ano" },
          { text: "Última OS", value: "ultima_os" },
          { text: "Cliente", value: "ultimo_cliente_id" },
          { text: "Data", value: "data_ultima_os" },
        ],
      };
    },

    methods: {
      async buscar() {
        try {
          if (this.busca && this.busca.length > 0) {
            this.carregando = true;

            const filtros = {
              ...(this.search_type === "contem"
                ? { descricao__contains: this.busca }
                : { descricao__startswith: this.busca }),
              marca__contains: this.busca,
              modelo__contains: this.busca,
              placa__contains: this.busca,
              ano__eq: this.busca,
            };

            this.itens_busca = await veiculosApi.buscar(filtros);

            this.atual = 0;
            setTimeout(() => {
              this.scrollList();
            }, 100);
          }
        } catch (error) {
          this.$eventbus.notificarErro('Não foi possível efetuar a busca.');
          console.log(error);
        } finally {
          this.carregando = false;
        }
      },

      adicionar() {
        abrirJanela(window.location.origin + '/#/cadastros/veiculos/adicionar');
      },

      onChangeSearchType(value) {
        console.log(value);
        this.search_type = value;
        this.buscar();
      },
    },
  }
</script>

<style scoped>

</style>
